const themeActionTypes = {
    RETRIEVED_CURRENT_THEMES: "RETRIEVED_CURRENT_THEMES",
    RETRIEVED_CURRENT_THEMEFILES: "RETRIEVED_CURRENT_THEMEFILES",

    RETRIEVED_EDITABLE_THEMEFILES: "RETRIEVED_EDITABLE_THEMEFILES",
    RETRIEVED_EDITABLE_TOKENS: "RETRIEVED_EDITABLE_TOKENS",
    RETRIEVED_EDITABLE_SETTINGS: "RETRIEVED_EDITABLE_SETTINGS",
    RETRIEVED_EDITABLE_VALUES: "RETRIEVED_EDITABLE_VALUES",

    UPDATE_THEME: "UPDATE_THEME",
    PARSE_THEME: "PARSE_THEME",
    RESTORE_THEME: "RESTORE_THEME",

    RETRIEVED_THEMES: "RETRIEVED_THEMES",
    APPLY_THEME: "APPLY_THEME",
    APPLY_DEFAULT_THEME: "APPLY_DEFAULT_THEME",
    DELETE_THEME: "DELETE_THEME" 
};
export default themeActionTypes;
